import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Order } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-floating-cart-price',
  templateUrl: './floating-cart-price.component.html',
  styleUrls: ['./floating-cart-price.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FloatingCartPriceComponent implements OnInit {
  @Input()
  currentCart: Order;

  constructor() {}

  ngOnInit() {}
}
